import {
  ActivitiesPageFilters,
  DurationFilter,
} from "domain/entities/activities.entities";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { VisualsSupports } from "ui/pages/app/visual-supports/VisualSupports";
import { VisualSupport } from "ui/pages/app/visual-supports/visual-support/VisualSupport";

export function VisualSupportsContainer() {
  const [searchParams] = useSearchParams();
  const [filters, setFilters] = useState<
    ActivitiesPageFilters & {
      [key: string]: string[] | string | boolean | number | DurationFilter;
    }
  >({
    supportObjectives: [],
  });

  return searchParams.get("id") ? (
    <VisualSupport selectedSupportId={searchParams.get("id")} />
  ) : (
    <VisualsSupports filters={filters} setFilters={setFilters} />
  );
}
